const zh = {
  // 通用
  loading: '加载中...',
  language: '语言',
  backHome: '返回首页',
  backUp: '返回上一页',
  page403: '抱歉，您无权访问该页面',
  page404: '抱歉，您访问的页面不存在',
  page500: '抱歉，服务器出错了',
  noData: '暂无数据',
  seq: '序号',
  status: '状态',
  importSeq: '请输入序号',
  add: '新增',
  delete: '删除',
  operate: '操作',
  edit: '编辑',
  query: '查询',
  date: '日期',
  to: '至',
  startTime: '开始时间',
  endTime: '结束时间',
  keywords: '关键字',
  importkeys: '请输入关键字',
  back: '返回',
  yes: '是',
  no: '否',
  save: '保 存',
  cancel: '取 消',
  enable: '启用',
  disabled: '禁用',
  lastweek: '最近一周',
  lasmonth: '最近一个月',
  lasmonth3: '最近三个月',
  // 导航栏
  goBackgourd: '进入后台',
  sysLogin: '系统登录',
  sysManagelogin: '系统管理登录',
  backManager: '安全管理平台 -后台管理',
  self_platform: '承包商自助平台',
  exam_platform: '在线培训考试 -PC',
  appliaction: '应用',
  trainexam: '在线培训考试 -移动端',
  mobile: '安全管理平台 -移动端',
  android_app: 'Android APP',

  homeTitle_01: '安全管理平台',
  homeTitle_011_child: '承包商管理',
  homeTitle_012_child: '安全教育',
  homeTitle_013_child: '检查违章',
  homeTitle_014_child: '工器具管理',
  homeTitle_015_child: '车辆管理',
  homeTitle_016_child: '系统管理',

  homeTitle_02: '规范化培训考试',
  homeTitle_021_child: '预约培训',
  homeTitle_022_child: '题库分类',
  homeTitle_023_child: '试卷管理',
  homeTitle_024_child: '人脸识别',
  homeTitle_025_child: '考试统计',
  homeTitle_026_child: '移动化培训管理',

  homeTitle_03: '违章检查',
  homeTitle_031_child: '违章录入',
  homeTitle_032_child: '违章审核',
  homeTitle_033_child: '违章管理',
  homeTitle_034_child: '违章条例',
  homeTitle_035_child: '事件调查',
  homeTitle_036_child: '违章统计',

  // 登录
  login: '登 录',
  username: '用户名',
  pwd: '密码',
  savePwd: '记住密码',
  validCode: '验证码',
  upvalidimg: '点击切换图片',
  importUserName: '请输入用户名',
  importPwd: '请输入密码',
  importPwdErr: '您的密码复杂度太低（必须包含字母、数字、特殊字符，8-20个字符）！',
  importvalidCode: '请输入验证码',
  loginSuccess: '登录成功',

  // 后台首页
  home: '首页',
  proscenium: '返回前台',
  outlogin: '退出登录',
  outok: '退出成功',

  // 首页 轮播图接口
  picture: '图片',
  importPic: '请上传图片',
  slideshow: '轮播图',

  // 首页分类
  menu: '菜单',
  selectMenu: '请选择菜单',
  name: '名称',
  Ename: '英文名称',
  importName: '请输入名称',
  importEName: '请输入英文名称',
  classify: '分类',

  // 文件上传控件
  upfileMsg: '将文件拖到此处，或',
  upfileMsg2: '只能上传jpg/png图片，且不超过500kb',
  upfileMsg3: '只能上传jpg/png图片',
  upfileMsg4: '上传图片大小不能超过 500kb',
  clickFile: '点击上传',

  // 首页内容
  title: '标题',
  importTit: '请输入标题',
  content: '内容',
  importClass: '请选择分类',
  importContent: '请输入内容',

  // 首页菜单
  path: '路径',
  importPath: '请输入路径',

  // 日志查询
  logtype: '日志类型',
  selectLogType: '请选择日志类型',
  clientTpe: '客户端类型',
  selectType: '请选择客户端类型',
  logTime: '日志时间',
  opUsername: '操作用户',
  exception: '异常',

  // 权限管理
  permissionName: '权限名称',
  importPermission: '请输入权限名称',
  interfaceAddress: '接口地址',
  importInterface: '请输入接口地址',
  remark: '描述信息',
  importRemark: '请输入描述信息',
  btnPermission: '按钮权限',

  // 菜单管理
  parentMenu: '父级菜单',
  selectParentMenu: '请选择父级菜单',
  menuCode: '菜单编码',
  importmenuCode: '请输入菜单编码',
  menuName: '菜单名称',
  importmenuName: '请输入菜单名称',
  menuType: '菜单类型',
  icon: '图标',
  importicon: '请输入图标',
  param: '参数',
  importParam: '请输入参数',
  isopen: '是否打开新窗口',
  isShowMenu: '是否显示在侧边栏',
  menuErrMsg: '菜单编码长度必须位于3到100之间',
  menuErrMsg2: '菜单名字长度必须位于2到50之间',

  // 角色管理
  RoleName: '角色名称',
  role: '角色',
  importRole: '请输入角色名称',
  roleCode: '角色编码',
  importRoleCode: '请输入角色编码',
  Rolekeywords: '请输入角色名称、编码',
  permissionEdit: '权限编辑',
  power: '权限',
  checkAll: '全选',

  // 基地管理
  baseName: '基地名称',
  base: '基地',
  importbaseName: '请输入基地名称',
  shortName: '基地简称',
  importBaseShortName: '请输入基地简称',
  baseCode: '基地编码',
  importbaseCode: '请输入基地名称',
  basekeywords: '请输入基地名称、编码',

  // 用户管理
  usercode: '用户编码',
  user: '用户',
  importUserCode: '请输入用户编码',
  position: '岗位',
  importposition: '请输岗位',
  email: '邮箱',
  importEmail: '请输入邮箱',
  emailErrMsg: '电子邮件格式有误',
  account: '账号',
  importAccount: '请输入账号',
  isAdmin: '是否管理员',
  phone: '电话',
  phoneErrMsg: '移动电话格式有误',
  importPhone: '请输入电话',
  userkeywords: '请输入用户名、账号、用户编码，电话',
  oldPassword: '旧密码',
  importOldPwd: '请输入旧密码',
  newPwd: '新密码',
  importNewPwd: '请输入新密码',
  confirmPwd: '确认密码',
  confirmAgain: '再次填写确认',
  updatePwd: '修改密码',
  pwdNotEqual: '两次填写密码不一致'
};
export default zh;
